import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';

@Pipe({ name: 'thousand' })
export class ThousandPipe implements PipeTransform {

    constructor() {

    }

    transform(value, locale) {

        if (!isNaN(value)) {
            return this.sortDecimal(parseFloat(value).toLocaleString(locale))
        } else {
            return ''
        }
    }

    sortDecimal(string) {
        let index = string.indexOf(",");
        if (index != -1) {
            string = string.substring(0, index + 3);
        }
        return string;
    }
}